export default "__VITE_ASSET__ab775a48__"